
import { Comprobante } from "./Comprobante";
import { TuplaRefacturacion } from "./TuplaRefacturacion";

export class RefacturacionFactura {
  id: string;
  motivo: number;
  facturaId: string;
  detalle: string;
  plazo: number;
  usuarioSolicitador: string;
  nombreArchivoAdjunto: string;
  prefijoNumeroAerovale: string; // quitar del nuevo seguimientoDTO
  codigoAeroplantaAerovale: string;
  // para devolver las candidatas
  esRefacturacionTotal: boolean;
  estado: number;
  factura: Comprobante;
  fechaHora: Date;
  motivoRechazo: any;
  usuarioValidador: string;
  usuarioAprobador: string;
  usuarioRevisador: string;
  pathAdjunto: string;
  valorAAnular: number;

  // para la actualizacion
  refacturacionesFacturasIds: string[];
  responsable: string;
  estadoFinal: number;
  tupla: TuplaRefacturacion[];

  // para la correccion de despacho
  aerovaleId: string;
  aerovaleSolicitanteId: string;
  aerovaleReemplazoDTO?: string;

  // seguimiento refacturacion
  aerovalePrefijo: string;
  aerovaleNumero: string;
  aerovaleNuevoPrefijo: string;
  aerovaleNuevoNumero: string;
  tipoSolicitud: number;
}


